export default {
  nav: {
    openMenu: 'Open menu',
    menuDescription: 'Choose a page from the Centratel menu.',
    supportRequests: 'All support requests',
    title: 'Customer portal',
    myCompanies: 'My companies',
    company: 'Company overview',
    holidays: 'Holidays',
    manage: 'Customer holidays',
    companyUsers: 'Company users',
  },
}
